import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultButton, Dropdown, Modal, PrimaryButton } from '@fluentui/react';
import FileSaver from 'file-saver';
import DocViewer, { DocViewerRenderers, IConfig } from '@r-uis/doc-viewer';
import { Document, Page } from 'react-pdf';
import * as Api from '../api/src';
import { saveAs } from 'file-saver';
import useToken from '../components/account/login/useToken';
const DocumentsApi = new Api.DocumentsApi();

export interface DocumentViewerProps {
  IsOpen: boolean;
  onCloseModal: () => void;
  onOkClick?: () => void;
  Item?: any;
}

const DocumentViewer = ({ Item, IsOpen, onCloseModal, onOkClick }: DocumentViewerProps) => {
  const { token } = useToken();
  const { t } = useTranslation();
  const [isShow, SetIsShow] = React.useState(false);
  const isImage = ['.gif', '.jpg', '.jpeg', '.png', '.webp', '.bmp']; //you can add more
  React.useEffect(() => {
    SetIsShow(IsOpen);
  }, [IsOpen]);
  const onClose = () => {
    onCloseModal();
    SetIsShow(false);
  };

  function getExtention(fileName: string): string {
    var ex = /[^.]+$/.exec(fileName);
    return ex ? '.' + ex['0'] : '';
  }
  const doc1 = [
    {
      uri: process.env.REACT_APP_API_ENDPOINT + '/api/Documents/' + Item.Id + '/' + Item.Name,
      fileName: Item.Name,
    },
  ];
  return (
    <Modal isOpen={isShow} isModeless={true}>
      <div className={'modal-content'} style={{ width: 1024 }}>
        {isImage.includes(getExtention(Item.Name as string)) && (
          // eslint-disable-next-line jsx-a11y/iframe-has-title
          <iframe
            width={'100%'}
            title=""
            height={700}
            src={`/editor/index.html?image=${doc1[0].uri}&url=${doc1[0].uri}&token=${token}`}
          ></iframe>
        )}
        {(Item.Name as string).toLowerCase().endsWith('.pdf') && (
          <embed width={'100%'} height={700} style={{ background: '#ddd' }} src={doc1[0].uri} type="application/pdf" />
        )}
        {!isImage.includes(getExtention(Item.Name as string)) &&
          !(Item.Name as string).toLowerCase().endsWith('.pdf') && (
            <DocViewer
              pluginRenderers={DocViewerRenderers}
              documents={doc1}
              config={{
                header: {
                  disableHeader: false,
                  disableFileName: false,
                  retainURLParams: false,
                },
              }}
              style={{ height: 700 }}
            />
          )}
      </div>
      <div className={'modal-footer'}>
        <PrimaryButton
          onClick={() => {
            DocumentsApi.apiDocumentsIdGet(Item.Id || 0, {
              responseType: 'blob',
            }).then((response) => {
              const rs = response as any;
              saveAs((response as any).data as Blob, `${Item.Name}`);
            });
            // FileSaver.saveAs(process.env.REACT_APP_API_ENDPOINT + '/api/Documents/' + Item.Id + '/' + Item.Name);
          }}
          className={'margin-left-10'}
        >
          {t('Download')}
        </PrimaryButton>
        <DefaultButton
          onClick={() => {
            onClose();
          }}
          className={'margin-left-10'}
        >
          {t('Close')}
        </DefaultButton>
      </div>
    </Modal>
  );
};
export default DocumentViewer;
